var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FFAC62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 8.325C8.1 7.93781 8.41281 7.625 8.8 7.625H15.8H17.2C18.7466 7.625 20 8.87844 20 10.425C20 11.9716 18.7466 13.225 17.2 13.225H16.5C16.5 14.3844 15.5594 15.325 14.4 15.325H10.2C9.04062 15.325 8.1 14.3844 8.1 13.225V8.325ZM16.5 11.825H17.2C17.9722 11.825 18.6 11.1972 18.6 10.425C18.6 9.65281 17.9722 9.025 17.2 9.025H16.5V11.825ZM6.7 16.025H17.9C18.2872 16.025 18.6 16.3378 18.6 16.725C18.6 17.1122 18.2872 17.425 17.9 17.425H6.7C6.31281 17.425 6 17.1122 6 16.725C6 16.3378 6.31281 16.025 6.7 16.025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCope);
export default __webpack_public_path__ + "static/media/cope.66c0ff542a66f4800fdcd2c6e0c4fbe9.svg";
export { ForwardRef as ReactComponent };